// Generated by CoffeeScript 1.12.2
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('views/components/loader',['require','backbone'],function(require) {
  var Loader, View;
  View = require('backbone').View;
  return Loader = (function(superClass) {
    extend(Loader, superClass);

    function Loader() {
      return Loader.__super__.constructor.apply(this, arguments);
    }

    Loader.prototype.el = "#loader";

    Loader.prototype.id = 'loader';

    Loader.prototype.initialize = function() {};

    Loader.prototype.loading = function() {
      return this.$el.hadClass('in');
    };

    Loader.prototype.show = function() {
      return this.$el.addClass('in').fadeIn();
    };

    Loader.prototype.hide = function() {
      return this.$el.addClass('out').fadeOut();
    };

    Loader.prototype.destroy = function(callback) {
      return this.$el.fadeOut((function(_this) {
        return function() {
          _this.$el.off().remove();
          return callback();
        };
      })(this));
    };

    return Loader;

  })(View);
});

